import React from "react";
import { Nav, Navbar } from "shards-react";
import NavbarToggle from "./NavbarToggle";
// import ameBrand from '../../images/ame_brand.svg'

class NavbarNav extends React.Component {
    render() {
        return (
            <Navbar
                type="light"
                className="align-items-stretch flex-md-nowrap p-0 d-md-none d-lg-none"
            >
                <Nav
                    className="border-left flex-row "
                    style={{
                        display: "flex",
                        width: "100%",
                        backgroundColor: "#FFF",
                        border: "1px solid #e1e5eb"
                    }}
                >
                    <NavbarToggle />
                    <Nav
                        style={{
                            flex: "1",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center"
                        }}
                    >
                        <span className="d-sm-inline  d-md-inline d-lg-none p-3 mr-5">
                            <h1>Portal de Eitri-Apps</h1>
                        </span>
                    </Nav>
                </Nav>
            </Navbar>
        );
    }
}

export default NavbarNav;
